import React, { useState, useEffect, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link } from 'react-router-dom';
import { useRef } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer, Line, LineChart, Pie, PieChart, Cell } from "recharts";
import CalendarWithTasks from './Calendar';
import Modal from 'react-modal';
import RelatorioTarefas from './RelatorioTarefas';
import Calendar from 'react-calendar';
import { language } from '../WEBContent/Language';
import { color } from '../WEBContent/Color';
import { icon } from '../WEBContent/Icon';

import { getTokenInfo } from './../../UseToken';
import UseSidebar from './../../UseSidebar';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import Loader from '../Loader/Loader';

import {
    set_language,
    reqGET,
    my_local_storage,
    get_my_fact_company,
    get_fact_legacy_info,
    reqDELETE,
    reqPOST,
    reqPUT,
    translate,
    simpleAxiosGet,
} from '../../Utils';

import Hosts from '../../Hosts'
import TaskList from './TaskList';
import GraficoPizzaEstadoTarefas from './GraficoPizzaEstadoTarefas';
import GraficoBarrasPrioridadeTarefas from "./GraficoBarrasPrioridadeTarefas"
import GraficoAdmin from './GraficoAdmin';
import GraficoTCMensal from './GraficoTCMensal';
import Agenda from '../Agenda/View';

//import { filter } from 'core-js/core/array';
import GraficoCircular from './GraficoCircular';
import { endOfDecadeWithOptions } from 'date-fns/fp';
import { set } from 'core-js/core/dict';
import Swal from 'sweetalert2'

export default function View(props) {
    const dados = useRef(null);
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');
    //const [, set_lang_id] = useState('1');

    //////////////////////////////////////////////////////////////////////////////
    //const [sortedData, setSortedData]=useState([])    
    const [entities, setEntities] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);

    //Tarefas
    const [tarefasConcluidas, setTarefasConcluidas] = useState(0);
    const [underdueTasks, setUnderdueTasks] = useState([]);
    const [overdueTasks, setOverdueTasks] = useState([]);
    const [tarefasDepartamento, setTarefasDepartamento] = useState([]);
    const [monitorTarefas, setMonitorTarefas] = useState([]);
    const [responsavelTarefas, setResponsavelTarefas] = useState([]);
    const [tarefasValidadas, setTarefasValidadas] = useState([]);
    const [tarefasNaoValidadas, setTarefasNaoValidadas] = useState([]);
    const [tasksUser, setTasksUser] = useState([])
    const [showAllTasks, setShowAllTasks] = useState(false);
    const [underdueTasksThisMonth, setunderdueTasksThisMonth] = useState([])
    const [overdueTasksThisMonth, setoverdueTasksThisMonth] = useState([])
    const [showWarning, setShowWarning] = useState(true);
    const [profile, setProfile] = useState(null);
    const [name, setName] = useState(null);
    const [userID, setuserID] = useState(null);
    const [monitoringTasks, setMonitoringTasks] = useState([]);
    const [ticketsUser, setTicketsuser] = useState([])
    const [beforeDeadlineCount, setBeforeDeadlineCount] = useState(0);
    const [afterDeadlineCount, setAfterDeadlineCount] = useState(0);
    const [sortOrder, setSortOrder] = useState({ key: null, direction: 'asc' });

    const [lastDismissalTime, setLastDismissalTime] = useState(() => {
        const storedTime = localStorage.getItem('modalDismissedTime');
        return storedTime ? new Date(parseInt(storedTime)) : null;
    });

    const [responsavelData, setResponsavelData] = useState(null);
    const [noticias, setNoticias] = useState([]);
    const [birthdays, setBirthdays] = useState([]);
    console.log('birthdays', birthdays)
    const [aniversariosHoje, setAniversariosHoje] = useState([]);

    //Items
    const [tasks, setTasks] = useState([]);
    const [tickets, setTickets] = useState([])
    const [eventos, setEventos] = useState([])
    const [formattedTasks, setFormattedTasks] = useState([]);
    const [formattedTickets, setFormattedTickets] = useState([]);
    const [formattedEventos, setFormattedEventos] = useState([]);
    const [options, setOptions] = useState([]);
    const [votes, setVotes] = useState({});
    const [isLocked, setIsLocked] = useState(false);

    // Dash Elements
    const [dash_admin, set_dash_admin] = useState(null)
    const [dash_entities, set_dash_entities] = useState(null)
    const [dash_news, set_dash_news] = useState(null)
    const [dash_tasks, set_dash_tasks] = useState(null)
    const [dash_energy, set_dash_energy] = useState(null)
    const [dash_agenda, set_dash_agenda] = useState(null)
    const [dash_eventos, set_dash_eventos] = useState(null)

    // Energy Management    
    const energy_type = useRef([]);
    const [selectedEnergyTypes, setSelectedEnergyTypes] = useState([]);

    //Sondagens e Agenda
    const entidades = useRef(null);
    const [feriados, setFeriados] = useState([]);
    const [futureTasks, setFutureTasks] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [activeStartDate, setActiveStartDate] = useState(new Date());

    const handleRowClick = (id) => {
        console.log('c_' + id)
        document.getElementById('c_' + id)?.click();
    };

    const handleRowEventClick = (id) => {
        console.log('handleRowEventClick id', id)
        console.log('document.getElementById("ce_' + id + '")?.click();')
        document.getElementById("ce_" + id)?.click();
    };

    const priorityColors = {
        normal: color.corNormal.hexa,
        naoUrgente: color.corNaoUrgente.rgb,
        poucoUrgente: color.corPoucoUrgente.rgb,
        urgente: color.corUrgente.hexa,
        critica: color.corCritica.rgb
    };

    const getPriorityColor = (priority) => {
        switch (priority) {
            case '1': return priorityColors.normal;
            case '2': return priorityColors.naoUrgente;
            case '3': return priorityColors.poucoUrgente;
            case '4': return priorityColors.urgente;
            case '5': return priorityColors.critica;
            default: return 'rgb(128, 128, 128)';
        }
    };

    const modalStyles = {
        modalOverlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: color.corShadow.rgba2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        },
        modalContent: {
            backgroundColor: color.cor3.hexa,
            padding: '20px',
            borderRadius: '10px',
            width: '600px',
            height: '600px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            marginBottom: '5%',
            overflow: 'hidden',
        },
        taskListContainer: {
            flex: 1,
            maxHeight: '500px',
            overflowY: 'auto',
            width: '100%',
            padding: '10px 15px',
            textAlign: 'start',
        },
        buttonContainer: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            marginTop: 'auto',
        },
        closeButton: {
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            backgroundColor: color.cor3.hexa,
            fontSize: '16px',
        },
    };

    const containerStyles = {
        container: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 16px',
            borderRadius: '8px',
            background: `rgba(255, 255, 255, 0.5)`,
            backdropFilter: 'blur(4px)',
            boxShadow: `0 2px 6px rgba(${color.corShadow.rgba2})`,
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        },
        value: {
            color: color.cor1.hexa,
            fontWeight: '500',
            textAlign: 'right',
        },
        label: {
            color: color.cor1.hexa,
            fontWeight: '500',
        },
    };

    const calendarStyles = `
  .custom-calendar {
    width: 100%;
    max-width: 100%;
    border: none;
    font-size: 1.2rem;
  }

  /* Navigation (month/year buttons) */
  .custom-calendar .react-calendar__navigation button {
    color: #222;
    min-width: 44px;
    background: none;
    font-size: 1.1rem;
    margin: 2px;
    border-radius: 8px;
    transition: background 0.2s;
    font-weight: 600;
  }
  .custom-calendar .react-calendar__navigation button:hover {
    background: #d9edf7; /* stronger hover */
  }

  /* Weekday labels */
  .custom-calendar .react-calendar__month-view__weekdays {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.9rem;
    color: #333;
  }

  /* Each tile (day cell) */
  .custom-calendar .react-calendar__tile {
    display: flex;
    flex-direction: column;      
    justify-content: space-between;
    align-items: center;
    height: 80px;
    padding: 5px;
    border-radius: 12px;
    transition: background 0.2s ease, color 0.2s ease;
    position: relative;
    font-weight: 500;
    color: #222;
  }

  /* Active (selected) day */
  .custom-calendar .react-calendar__tile--active {
    background: #54B4D3;
    color: #fff;           
    font-weight: 700;
    border-radius: 12px;
  }

  /* Hover effect */
  .custom-calendar .react-calendar__tile:hover {
    background: #b3e5fc;  
    cursor: pointer;
  }

  /* Today highlight */
  .custom-calendar .react-calendar__tile--now {
    background: #ffecb3;   
    border: 2px solid #f9a825; 
    font-weight: 700;
    color: #222;
    border-radius: 12px;
  }

  /* Disabled tiles (weekends) */
  .custom-calendar .react-calendar__tile:disabled {
    background: #f5f5f5;
    color: #aaa;
    cursor: not-allowed;
  }

  /* Custom wrapper inside each tile */
  .custom-calendar .tile-inner {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;
  }

  /* Day number styling */
  .custom-calendar .day-number {
    font-weight: bold;
    font-size: 1rem;
    align-self: flex-start;  
  }

  /* Bottom icons/content */
  .custom-calendar .day-icons {
    font-size: 0.85rem;
    color: #444;
    margin-top: auto;
    text-align: center;
    width: 100%;
  }
  `;

    ////////////////////////////////////////////////////////////////////////

    const tableConfig = {
        styles: {
            table: {
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '12px',
                color: color.cor1.hexa,
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                borderRadius: '6px',
                overflow: 'hidden',
                backgroundColor: color.cor3.hexa,
                marginBottom: '12px',
            },
            headerCell: {
                padding: '6px 8px',
                textAlign: 'left',
                color: color.cor3.hexa,
                fontWeight: '600',
                borderBottom: '1px solid #ddd',
                backgroundColor: color.cor2.rgb,
                textTransform: 'uppercase',
            },
            cell: {
                borderBottom: `1px solid rgb(${color.cor3.rgb})`,
                textAlign: 'left',
                verticalAlign: 'middle',
                padding: '6px 8px',
                color: color.corCinza.hexa,
                lineHeight: '1.3',
                backgroundColor: color.cor3.hexa,
            },
            row: {
                backgroundColor: color.cor3.hexa,
                transition: 'background-color 0.2s ease',
                cursor: 'pointer',
            },
            sortButton: {
                color: color.cor3.hexa,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                marginLeft: '4px',
            },
        },
        headers: [
            { key: 'name', label: language[lang].task_resp, visible: true },
            { key: 'data_realizacao', label: language[lang].data_realizacao, visible: true },
            { key: 'data_submissao', label: language[lang].data_submissao, visible: true },
            { key: 'data_limite', label: language[lang].data_limite, visible: true },
            { key: 'estado', label: language[lang].table_state, visible: true },
        ],
        getCellColor: (task) => {
            if (task.info.dataConclusao && new Date(task.info.dataConclusao) < new Date(task.info.data_limite))
                return color.corVerde.rgb
            if (new Date(task.info.data_limite) < new Date())
                return color.corVermelha.rgb
            if (new Date(task.info.data_limite) <= new Date(new Date().setDate(new Date().getDate() + 7)))
                return color.corLaranja.rgb
            return color.corCinza.hexa
        },
    }

    const getEstadoStyle = (estado, lang) => {
        // Acessando o label do estado (usando a tradução de acordo com o idioma)
        const estadoLabel = lang === 'en' ? estado.labelEn : estado.labelPt;

        // Aplicando o estilo com base no label traduzido
        switch (estadoLabel) {
            case 'Concluído':
            case 'Completed':
                return { color: color.cor3.rgb, backgroundColor: color.corVerde.rgb }; // Verde
            case 'Em Progresso':
            case 'In Progress':
                return { color: color.cor3.rgb, backgroundColor: color.corNormal.hexa }; // Azul
            case 'Em Execução':
            case 'In Execution':
                return { color: color.cor3.rgb, backgroundColor: color.corUrgente.hexa }; // Laranja
            case 'Pendente':
            case 'Pending':
                return { color: color.cor3.rgb, backgroundColor: color.corCritica.rgb }; // Vermelho
            case 'A Iniciar':
            case 'To Start':
                return { color: color.cor3.rgb, backgroundColor: color.corAmarela.rgb3 }; // Amarelo
            case 'Em Revisão':
            case 'Under Revision':
                return { color: color.cor3.rgb, backgroundColor: color.corRoxa.rgb }; // Roxo
            case 'Cancelado':
            case 'Canceled':
                return { color: color.cor3.rgb, backgroundColor: color.cor4.rgb }; // Cinza
            default:
                return { color: color.cor3.rgb, backgroundColor: color.corCinza.rgb3 }; // Cinza Claro
        }
    };

    const getPrioridadeStyle = (estado) => {
        switch (estado) {
            case 'Normal':
                return { color: color.cor3.rgb, backgroundColor: color.corNormal.hexa, fontWeight: '400' } // Azul
            case 'Urgente':
            case 'Urgent':
                return { color: color.cor3.rgb, backgroundColor: color.corUrgente.hexa, fontWeight: '400' }; // Laranja Claro
            case 'Crítico':
            case 'Critical':
                return { color: color.cor3.rgb, backgroundColor: color.corCritica.rgb, fontWeight: '400' } // Vermelho Claro
            case 'Pouco Urgente':
            case 'Low Priority':
                return { color: color.cor3.rgb, backgroundColor: color.corRoxa.rgb, fontWeight: '400' } // Verde Claro
            case 'Não Urgente':
            case 'Not Urgent':
                return { color: color.cor3.rgb, backgroundColor: color.corVerde.rgb, fontWeight: '400' } // Lima
            default:
                return { color: color.cor3.rgb, backgroundColor: color.cor4.rgb, fontWeight: '400' } // Cinza
        }
    };

    const prioridadeOrdem = [
        'Crítico', 'Critical',
        'Urgente', 'Urgent',
        'Pouco Urgente', 'Low Priority',
        'Não Urgente', 'Not Urgent',
        'Normal',
    ];

    const sortedTasks = [...tasks].sort((a, b) => {
        const prioridadeA = a.info.prioridade ? (lang === 'en' ? a.info.prioridade.labelEn : a.info.prioridade.labelPt) : 'Sem Prioridade';
        const prioridadeB = b.info.prioridade ? (lang === 'en' ? b.info.prioridade.labelEn : b.info.prioridade.labelPt) : 'Sem Prioridade';

        return prioridadeOrdem.indexOf(prioridadeA) - prioridadeOrdem.indexOf(prioridadeB);
    });

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortOrder.key === key && sortOrder.direction === 'asc') {
            direction = 'desc';
        }
        setSortOrder({ key, direction });
    };

    const orderTasks = [...responsavelTarefas].sort((a, b) => {
        if (!sortOrder.key) return 0;

        const aValue = a.info[sortOrder.key];
        const bValue = b.info[sortOrder.key];

        if (aValue === undefined || bValue === undefined) return 0;

        if (typeof aValue === 'string') {
            return sortOrder.direction === 'asc'
                ? aValue.localeCompare(bValue)
                : bValue.localeCompare(aValue);
        } else if (!isNaN(new Date(aValue))) {
            return sortOrder.direction === 'asc'
                ? new Date(aValue) - new Date(bValue)
                : new Date(bValue) - new Date(aValue);
        } else {
            return sortOrder.direction === 'asc' ? aValue - bValue : bValue - aValue;
        }
    });

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    const truncateText = (text, wordLimit) => {
        if (!text) return '';
        const words = text.split(' ');
        return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : text;
    };

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {

            permissions.current = []

            for await (let node of sidebar) {

                let name = node.path.split('_')
                name.pop()
                name = name.join('_')

                if (name !== '' || node.admin) {

                    let aux = {}
                    aux = { create: node.create, edit: node.edit, view: true, remove: node.remove, dash: node.dash, admin: node.admin }

                    if (permissions.current === null) {
                        permissions.current = []
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current.push({
                        name: name !== '' ? name : node.path,
                        permissions: aux
                    }))

                }
            }

        }

        await handleSingleCheck(e, sidebar)
    }

    // Filter states
    const [filterMonth, setFilterMonth] = useState('');
    const [filterYear, setFilterYear] = useState('');
    const [filterEnergyType, setFilterEnergyType] = useState('');

    const filteredEnergyTypes = selectedEnergyTypes.filter(item => {
        const itemDate = new Date(item.data);
        const itemMonth = itemDate.getMonth() + 1;
        const itemYear = itemDate.getFullYear();

        const matchMonth = filterMonth ? parseInt(filterMonth) === itemMonth : true;
        const matchYear = filterYear ? parseInt(filterYear) === itemYear : true;
        const matchEnergyType = filterEnergyType ? String(item.id) === String(filterEnergyType) : true;

        return matchMonth && matchYear && matchEnergyType;
    });

    const MONTH_NAMES = [
        language[lang].janeiro,
        language[lang].fevereiro,
        language[lang].marco,
        language[lang].abril,
        language[lang].maio,
        language[lang].junho,
        language[lang].julho,
        language[lang].agosto,
        language[lang].setembro,
        language[lang].outubro,
        language[lang].novembro,
        language[lang].dezembro
    ];

    const conversionTable = {
        L: { factor: 0.001, target: 'm³' },
        kWh: { factor: 0.000215, target: 'tep' },
        kg: { factor: 0.001, target: 't' },
        'm³': { factor: 0.98, target: 'tep' },
        t: { factor: 0.33, target: 'tep' },
    };

    const fuelSpecificConversions = {
        diesel: {
            t: { factor: 1.01, target: 'tep' },
            'm³': { factor: 0.98, target: 'tep' },
        },
        gasolina: {
            t: { factor: 1.05, target: 'tep' },
            'm³': { factor: 0.86, target: 'tep' },
        },
        biodiesel: {
            t: { factor: 0.86, target: 'tep' },
            'm³': { factor: 0.78, target: 'tep' },
        },
        bioetanol: {
            t: { factor: 0.64, target: 'tep' },
            'm³': { factor: 0.51, target: 'tep' },
        },
    };

    function parseCost(cost) {
        if (!cost) return 0;

        const normalized = String(cost)
            .replace(/[^\d.,]/g, '')
            .replace(',', '.');

        const parsed = parseFloat(normalized);
        return isNaN(parsed) ? 0 : parsed;
    }

    const tepByUnit = {};

    filteredEnergyTypes.forEach((item) => {
        const unit = item.unidade?.trim();
        const conversion = conversionTable[unit];
        const consume = parseCost(item.consume);

        if (conversion) {
            const convertedTEP = consume * conversion.factor;

            if (!tepByUnit[unit]) {
                tepByUnit[unit] = {
                    totalTEP: 0,
                    targetUnit: conversion.target,
                    conversionFactor: conversion.factor,
                };
            }

            tepByUnit[unit].totalTEP += convertedTEP;
        }
    });

    const monthlyDataByType = useMemo(() => {
        const consumeResult = {};
        const custoIvaResult = {};

        filteredEnergyTypes.forEach(item => {
            const date = new Date(item.data);
            const year = date.getFullYear();
            const month = date.getMonth();
            const key = `${year}-${String(month + 1).padStart(2, '0')}`;
            const monthLabel = `${MONTH_NAMES[month]} ${year}`;

            const energyName = item.name || 'Unknown';

            if (!consumeResult[key]) consumeResult[key] = { date: key, label: monthLabel };
            if (!custoIvaResult[key]) custoIvaResult[key] = { date: key, label: monthLabel };

            consumeResult[key][energyName] =
                (consumeResult[key][energyName] || 0) + parseCost(item.consume);
            custoIvaResult[key][energyName] =
                (custoIvaResult[key][energyName] || 0) + parseCost(item.custo_iva);
        });

        const consumeArray = Object.values(consumeResult)
            .sort((a, b) => new Date(a.date) - new Date(b.date));
        const custoIvaArray = Object.values(custoIvaResult)
            .sort((a, b) => new Date(a.date) - new Date(b.date));

        return { consumeArray, custoIvaArray };

    }, [filteredEnergyTypes, MONTH_NAMES]);

    const tepByLabel = useMemo(() => {
        const result = {};

        filteredEnergyTypes.forEach((item) => {
            const label = item.label;
            const unit = item.unidade?.trim();
            const consume = parseCost(item.consume);
            let tep = 0;

            if (!label || !unit || !consume || !item.periodo) return;

            const fuelConversion = fuelSpecificConversions[label.toLowerCase()];
            if (fuelConversion && fuelConversion[unit]) {
                tep = consume * fuelConversion[unit].factor;
            } else if (conversionTable[unit]) {
                tep = consume * conversionTable[unit].factor;
            } else {
                return;
            }

            if (!result[label]) result[label] = 0;
            result[label] += tep;
        });

        return Object.entries(result).map(([label, value]) => ({ name: label, value: Number(value.toFixed(2)) }));

    }, [filteredEnergyTypes]);

    const COLORS = [
        color.cor1.rgb,
        color.corPrimaria.rgb,
        color.corAmarela.rgb3,
        color.corRoxa.rgb,
        color.corLima.rgb,
        color.corVerde.rgb,
        color.corLaranja.rgb,
        color.corVermelha.rgb,
        color.corVerde.rgb,
    ];

    const randomizedColors = useMemo(() => {
        const shuffled = [];
        const aux = new Set();

        for (const c of COLORS) {
            if (!aux.has(c)) {
                aux.add(c);
                shuffled.push(c);
            }
        }

        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }

        return shuffled;
    }, []);

    const unitMap = useMemo(() => {
        return filteredEnergyTypes.reduce((acc, item) => {
            if (item.name && item.unidade) {
                acc[item.name] = item.unidade;
            }
            return acc;
        }, {});
    }, [filteredEnergyTypes]);

    const { enrichedTepByLabel, colorMap } = useMemo(() => {
        const colorMap = {};
        const enrichedTepByLabel = tepByLabel.map((item, idx) => {
            colorMap[item.name] = randomizedColors[idx % randomizedColors.length];
            return {
                ...item,
                unidade: unitMap[item.name] || '',
            };
        });

        return { enrichedTepByLabel, colorMap };
    }, [tepByLabel, unitMap, randomizedColors]);

    const CustomTooltipConsume = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px' }}>
                    <p><strong>{label}</strong></p>
                    {payload.map((entry) => {
                        const energyName = entry.name || entry.payload?.name;
                        const unit = unitMap[energyName] || entry.payload?.unidade || '';
                        const color = colorMap[energyName] || '#000';

                        return (
                            <p key={entry.dataKey} style={{ color, margin: 0 }}>
                                {energyName}: {entry.value.toFixed(2)} {unit}
                            </p>
                        );
                    })}
                </div>
            );
        }
        return null;
    };

    const CustomToolBar = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px' }}>
                    <p><strong>{label}</strong></p>
                    {payload.map((entry) => {
                        const energyName = entry.dataKey || entry.name || entry.payload?.name;
                        const unit = unitMap[energyName] || entry.payload?.unidade || '';
                        const color = entry.color || colorMap[energyName] || '#000';
                        const value = entry.value;

                        return (
                            <p key={energyName} style={{ color, margin: 0 }}>
                                {value.toFixed(2)} {unit}
                            </p>
                        );
                    })}
                </div>
            );
        }
        return null;
    };

    const CustomTooltipCustoIva = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px' }}>
                    <p><strong>{label}</strong></p>
                    {payload.map((entry) => (
                        <p key={entry.dataKey} style={{ color: colorMap[entry.name] || '#000', margin: 0 }}>
                            {entry.name}: {entry.value.toFixed(2)} €
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };

    const order_array = (array) => {

        return array.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // ignore upper and lowercase
            const nameB = b.name.toUpperCase(); // ignore upper and lowercase
            
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            // names must be equal
            return 0;
        });
    }

    useEffect(() => {

        (async () => {

            const get_attr = async () => {
                let res = await fetch_maintenance_attributes('energy_type');
                if (res.length > 0) {
                    res = order_array(res);

                    let res_aux = [];
                    for await (let el of res) {
                        res_aux.push({
                            ...el,
                            label: el.name,
                            unidade: el.unidade,
                            iva: {
                                id: el.iva?.id || '',
                                nome: el.iva?.nome || '',
                                taxa: el.iva?.taxa || 0,
                            }
                        });
                    }
                    set_dados(energy_type.current = res_aux)
                    //console.log("Energy Types:", energy_type.current)
                }

                setLoading(false);

                return true

            }

            set_dash_admin(false)
            set_dash_news(false)
            set_dash_entities(false)
            set_dash_tasks(false)
            set_dash_energy(false)
            set_dash_agenda(false)
            set_dash_eventos(false)

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions('*', v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions('*', v) })
                }

            }

            let aux_home = permissions.current.filter(e => e.name === '/')
            if (Array.isArray(aux_home) && aux_home.length > 0) {
                if (aux_home[0].permissions.admin !== undefined && aux_home[0].permissions.admin === true) {
                    set_dash_admin(true)
                }
            }

            let aux_news = permissions.current.filter(e => e.name.includes('news'))
            if (Array.isArray(aux_news) && aux_news.length > 0) {
                if (aux_news[0].permissions.dash !== undefined && aux_news[0].permissions.dash === true) {
                    set_dash_news(true)

                    const fetchNoticias = async () => {
                        try {
                            const res = await reqGET(`${Hosts.SIMCore_API}/web/content/type/${getTokenInfo().companycode}/news`);

                            if (res?.data) {
                                const news = res.data;
                                setNoticias(news)
                                //console.log('News', news)
                            }
                        } catch (error) {
                            console.error("Erro:", error);
                        }
                    }
                    await fetchNoticias();
                }
            }

            let aux_eventos = permissions.current.filter(e => e.name.includes('evento'))
            if (Array.isArray(aux_eventos) && aux_eventos.length > 0) {
                if (aux_eventos[0].permissions.dash !== undefined && aux_eventos[0].permissions.dash === true) {
                    set_dash_eventos(true)

                    const fetchEventos = async () => {
                        try {
                            const res = await reqGET(`${Hosts.SIMCore_API}/evento/type/${getTokenInfo().companycode}/evento`);

                            if (res?.data) {
                                const eventos = res.data;
                                setEventos(eventos);
                                //console.log("Eventos", eventos);
                            }

                            const userEventos = (res?.data || []).filter((evento) => {
                                if (!evento.info || !Array.isArray(evento.info.responsaveis) || evento.info.responsaveis.length === 0) {
                                    return true;
                                }
                                return evento.info.responsaveis.some((p) => String(p.id) === String(userID));
                            });

                            const eventos = userEventos.map((evento) => ({
                                id: `evento-${evento.id}`,
                                title: evento.info?.title || evento.info?.name || "Evento sem título",
                                color: color.corVerde.hexa3, // Cor padrão para eventos
                                start: evento.info?.data_inicio,
                                end: evento.info?.data_fim,
                                type: "evento",
                                extendedProps: evento.info || {},
                            }));

                            setFormattedEventos(eventos);

                        } catch (error) {
                            console.error("Erro ao buscar eventos:", error);
                        }
                    };

                    await fetchEventos();

                }
            }

            let aux_agenda = permissions.current.filter(e => e.name.includes('agenda'))
            if (Array.isArray(aux_agenda) && aux_agenda.length > 0) {
                if (aux_agenda[0].permissions.dash !== undefined && aux_agenda[0].permissions.dash === true) {
                    set_dash_agenda(true)
                }
            }

            let aux_energy = permissions.current.filter(e => e.name.includes('energy'))
            if (Array.isArray(aux_energy) && aux_energy.length > 0) {
                if (aux_energy[0].permissions.dash !== undefined && aux_energy[0].permissions.dash === true) {
                    set_dash_energy(true)

                    const fetchSubmittedEnergyTypes = async () => {
                        try {
                            const response = await reqGET(`${api_crud_base}/intranet/maintenance/type/${getTokenInfo().companycode}/energy`);

                            const formatted = response.data.map(entry => {
                                const custo = parseCost(entry.info.custo);
                                const ivaRate = entry.info.iva?.taxa || 0;
                                const custo_iva = (custo * (1 + ivaRate / 100)).toFixed(2);

                                const rawDate = entry.info.data;
                                const validDate = rawDate && !isNaN(new Date(rawDate).getTime()) ? rawDate : null;

                                return {
                                    energy_id: entry.id || entry._id,
                                    id: entry.info.energy_type.id,
                                    numero_documento: entry.info.numero_documento,
                                    name: entry.info.energy_type.name,
                                    unidade: entry.info.energy_type.unidade,
                                    label: entry.info.energy_type.name,
                                    consume: entry.info.consume,
                                    data: validDate,
                                    periodo: entry.info.periodo,
                                    custo: custo.toFixed(2),
                                    custo_iva,
                                };
                            });

                            setSelectedEnergyTypes(formatted);
                        } catch (error) {
                            console.error('Failed to fetch submitted energy types:', error);
                        }
                    };

                    await fetchSubmittedEnergyTypes();
                }

                await get_attr()

            }

            let aux_entities = permissions.current.filter(e => e.name.includes('entidade'))
            if (Array.isArray(aux_entities) && aux_entities.length > 0) {
                if (aux_entities[0].permissions.dash !== undefined && aux_entities[0].permissions.dash === true) {
                    set_dash_entities(true)

                    const fetchEntities = async () => {
                        try {
                            const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/`);
                            //console.log("Data: ", res);

                            const entitiesOptions = res.data.map(entity => ({
                                label: entity.name,
                                value: entity.id,
                                departamento: entity.departamento,
                                email: entity.email,
                                aniversario: entity.birthday,
                            }));

                            setEntities(entitiesOptions);

                        } catch (error) {
                            console.error("Erro:", error);
                        }
                    }
                    await fetchEntities()
                }
            }

            let aux_tarefas = permissions.current.filter(e => e.name.includes('tarefa'))
            if (Array.isArray(aux_tarefas) && aux_tarefas.length > 0) {
                if (aux_tarefas[0].permissions.dash !== undefined && aux_tarefas[0].permissions.dash === true) {
                    set_dash_tasks(true)

                    const fetchTasks = async () => {
                        try {
                            const response = await reqGET(`${Hosts.SIMCore_API}/tarefa/${getTokenInfo().companycode}`);

                            const currentDate = new Date();
                            const currentMonth = currentDate.getMonth();
                            const currentYear = currentDate.getFullYear();

                            const tasks = response.data;
                            const responsavelCounts = {};

                            for await (let task of tasks) {
                                if (task.info && task.info.responsaveis && task.info.validar) {
                                    const taskDeadline = new Date(task.info.data_limite);

                                    const dataConclusao = task.info.dataSubmissao
                                        ? new Date(task.info.dataConclusao)
                                        : (task.info.solucao && task.info.solucao.length > 0
                                            ? new Date(task.info.solucao[0].dataAtual)
                                            : null);
                                    //console.log("dataConclusao:", dataConclusao, "taskDeadline:", taskDeadline);

                                    if (dataConclusao) {
                                        // task.info.responsaveis.forEach(responsavel => {
                                        for await (let responsavel of task.info.responsaveis) {
                                            const label = responsavel.label;

                                            // Initialize the counts if not already present
                                            if (!responsavelCounts[label]) {
                                                responsavelCounts[label] = { onTime: 0, late: 0 };
                                            }

                                            // Compare taskDeadline with dataConclusao
                                            if (taskDeadline < dataConclusao) {
                                                responsavelCounts[label].onTime += 1;
                                            } else {
                                                responsavelCounts[label].late += 1;
                                            }
                                        }
                                        // });
                                    }
                                }
                            }
                            // });

                            // Convert the result to an array of objects if needed
                            const responsavelArray = Object.entries(responsavelCounts).map(([label, counts]) => ({
                                label,
                                onTime: counts.onTime,
                                late: counts.late
                            }))
                            setResponsavelData(responsavelArray)

                            if (response?.data) {
                                const allTasks = response.data;

                                const departamentoTasks = allTasks.filter(task =>
                                    task.info?.departamentoResponsaveis?.responsaveis?.some(responsavel => responsavel.value === userID)
                                );
                                setTarefasDepartamento(departamentoTasks);

                                const monitorTasks = allTasks.filter(task =>
                                    task.info?.monitor?.some(monitor => monitor.value === userID)
                                );
                                setMonitorTarefas(monitorTasks);
                                // console.log("monitorTasks", monitorTasks)

                                const responsaveisTasks = allTasks.filter(task =>
                                    task.info?.responsaveis?.some(responsavel => responsavel.value === userID) &&
                                    task.info?.departamentoResponsaveis?.responsaveis?.some(responsavel => responsavel.value === userID)
                                )

                                setResponsavelTarefas(responsaveisTasks);

                                const naoValidadas = allTasks.filter(task =>
                                    task.info?.monitor?.some(monitor => monitor.value === userID) &&
                                    task.info.estado.value != 2 &&
                                    task.info.validar === false
                                );
                                setTarefasNaoValidadas(naoValidadas);
                                // console.log('naoValidadas', naoValidadas);

                                const validadas = allTasks.filter(task =>
                                    task.info?.monitor?.some(monitor => monitor.value === userID) &&
                                    task.info.validar === true
                                );
                                setTarefasValidadas(validadas);
                                // console.log('validadas', validadas);

                                const validatedTasks = responsaveisTasks.filter(task => task.info.validar === true &&
                                    task.info?.responsaveis?.some(responsavel => responsavel.value === userID)
                                );

                                const validatedTasksThisMonth = await responsaveisTasks.filter(task =>
                                    task.info.validar === true &&
                                    task.info?.responsaveis?.some(responsavel => responsavel.value === userID) &&
                                    new Date(task.info.solucao.dataAtual).getMonth() === currentMonth &&
                                    new Date(task.info.solucao.dataAtual).getFullYear() === currentYear
                                );

                                //////////////////////////////////////////////////////////////////

                                // Tarefas atrasadas do mês atual
                                const overdueTasksThisMonth = validatedTasksThisMonth.filter(task =>
                                    new Date(task.info.solucao.dataAtual) > new Date(task.info.data_limite) &&
                                    task.info?.responsaveis?.some(responsavel => responsavel.value === userID)
                                );
                                setoverdueTasksThisMonth(overdueTasksThisMonth)

                                //////////////////////////////////////////////////////////////////

                                const underdueTasks = validatedTasks.filter(task =>
                                    new Date(task.info.solucao.dataAtual) <= new Date(task.info.data_limite) &&
                                    task.info?.responsaveis?.some(responsavel => responsavel.value === userID)
                                );
                                setunderdueTasksThisMonth(underdueTasksThisMonth)

                                //////////////////////////////////////////////////////////////////

                                const overdueTasks = validatedTasks.filter(task =>
                                    new Date(task.info.solucao.dataAtual) > new Date(task.info.data_limite) &&
                                    task.info?.responsaveis?.some(responsavel => responsavel.value === userID)
                                );
                                validatedTasks.forEach(task => {
                                    const dataAtual = new Date(task.info.solucao.dataAtual); // Alterado para solucao.dataAtual
                                    const dataLimite = new Date(task.info.data_limite);

                                    if (dataAtual <= dataLimite) {
                                        setBeforeDeadlineCount(prevCount => prevCount + 1);
                                    } else {
                                        setAfterDeadlineCount(prevCount => prevCount + 1);
                                    }
                                });

                                //////////////////////////////////////////////////////////////////

                                const userTasks = response.data.filter(
                                    (task) =>
                                        Array.isArray(task.info.responsaveis) &&
                                        task.info.responsaveis.some((r) => r.value === userID)
                                );

                                const formattedTasks = userTasks
                                    .filter((task) => task.info.status?.value !== "Cancelado")
                                    .map((task) => ({
                                        id: task.id,
                                        title: task.info.name || "Sem título",
                                        color: getPriorityColor(task.info.prioridade?.value),
                                        extendedProps: {
                                            ...task.info,
                                            data_inicio: task.info.data_inicio,
                                            data_limite: task.info.data_limite,
                                            dataConclusao: task.info.dataConclusao,
                                        },
                                        type: "tarefa",
                                    }));

                                setFormattedTasks(formattedTasks);
                                //console.log("$$$$$$$$$$$ Formatted Tasks:", formattedTasks);

                                //////////////////////////////////////////////////////////////////

                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                const nextWeek = new Date(today);
                                nextWeek.setDate(today.getDate() + 7);

                                const futureFiltered = responsaveisTasks.filter((t) => {
                                    if (t.extendedProps?.estado?.value === 2) return false;

                                    const inicio = parseLocalDate(t.extendedProps?.data_inicio);
                                    const limite = parseLocalDate(t.extendedProps?.data_limite);

                                    const refDate = limite || inicio;
                                    if (!refDate) return false;

                                    return refDate > today && refDate <= nextWeek;
                                });

                                setFutureTasks(
                                    Array.from(new Map(futureFiltered.map((t) => [t.id, t])).values())
                                );
                                //console.log("futureTasks", futureTasks)

                                setTarefasConcluidas(validatedTasks.length);
                                setUnderdueTasks(underdueTasks);
                                setOverdueTasks(overdueTasks);
                                //setTasks(allTasks);
                                setTasks(responsaveisTasks);
                                //console.log('allTasks', allTasks)
                            } else {
                                console.log("Nenhum dado de tasks foi retornado.");
                            }
                        } catch (error) {
                            console.error("Erro:", error);
                        }
                    }
                    await fetchTasks()
                }
            }

            const fetchTickets = async () => {
                try {
                    const res = await reqGET(`${Hosts.SIMCore_API}/intranet/suporte/${getTokenInfo().companycode}`);

                    //console.log('Tickets', res);
                    setTickets(res.data);

                    // Filtrando os tickets do usuário logado
                    const ticketsUser = tickets.filter(ticket =>
                        ticket.info?.colaborador?.[0]?.value === userID
                    );

                    setTicketsuser(ticketsUser);
                    //console.log("Tickets do utilizador logado", ticketsUser);
                } catch (error) {
                    console.error("Erro ao buscar os tickets:", error);
                }
            }
            await fetchTickets()

            const fetchDepartamentos = async () => {
                try {
                    const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
                    if (res?.data) {
                        setDepartamentos(res.data);
                        //console.log("Departamentos", res.data)
                    } else {
                        console.warn("Resposta inesperada ao buscar departamentos:", res);
                    }
                } catch (error) {
                    console.error("Erro ao buscar os departamentos:", error);
                }
            }
            await fetchDepartamentos()

            if (userID !== null)
                setLoading(false)

            //await get_attr()

        })()

        const fetch_maintenance_attributes = async (type) => {

            let res = await reqGET(`${api_crud_base}/intranet/maintenance/attribute/type/${getTokenInfo().companycode}/${type}`)
            let result = []

            if (res.data !== undefined) {
                for await (let el of res.data) {
                    let aux = {
                        id: el.id,
                        name: translate(el.info.title, 'pt'),
                        unidade: el.info.unidade,
                        iva: {
                            id: el.info.iva?.id || '',
                            nome: el.info.iva?.nome || '',
                            taxa: el.info.iva?.taxa || 0,
                        }
                    }

                    result.push(aux)
                }
            }

            return result

        }

        const fetch_entidades = async () => {
            try {
                let res_entidade = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/*`);
                let data = res_entidade.data ?? [];

                let result = data.filter(el => el.entity_type === "1");

                set_dados(entidades.current = result);

                setEntities(result);
                //console.log("Entidades:", result);

                const birthdays = result
                    .filter(entity => entity.birthday)
                    .map(entity => ({
                        id: entity.id,
                        name: entity.name,
                        birthday: entity.birthday
                    }));

                setBirthdays(birthdays);
                //console.log("Aniversários:", birthdays);

                const today = new Date();
                const todayDay = today.getDate();
                const todayMonth = today.getMonth() + 1;

                const aniversariosHoje = result.filter(entity => {
                    if (!entity.birthday) return false;
                    const [year, month, day] = entity.birthday.split('-').map(Number);
                    return day === todayDay && month === todayMonth;
                });

                setAniversariosHoje(aniversariosHoje);
                //console.log("Aniversários Hoje:", aniversariosHoje);

                if (aniversariosHoje.length > 0) {
                    setShowWarning(true);
                }

            } catch (error) {
                console.error("Erro ao buscar as Entidades:", error);
                return [];
            }
        };

        fetch_entidades();

    }, [userID]);

    const isSameDay = (d1, d2) =>
        d1 && d2 &&
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate();

    const isWeekend = (date) => {
        const day = date.getDay();
        return day === 0 || day === 6;
    };

    const parseLocalDate = (dateString) => {
        if (!dateString) return null;
        const d = new Date(dateString);
        d.setHours(0, 0, 0, 0);
        return d;
    };

    useEffect(() => {
        const fetchHolidays = async () => {
            const year = activeStartDate.getFullYear();
            const [holidayResponse] = await Promise.all([
                simpleAxiosGet(
                    `https://services.sapo.pt`,
                    `/Holiday/GetNationalHolidays?year=${year}`
                ),
            ]);

            const Holidays = await holidayResponse;
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(Holidays, "text/xml");
            const holidayNodes = xmlDoc.getElementsByTagName("Holiday");

            const feriadosParsed = Array.from(holidayNodes).map((node) => {
                const name = node.getElementsByTagName("Name")[0]?.textContent || "";
                const dateRaw = node.getElementsByTagName("Date")[0]?.textContent || "";

                const dateObj = new Date(dateRaw);
                const date = formatDate(dateObj);

                return { date, name };
            });

            setFeriados(feriadosParsed);
            //console.log("Feriados:", feriadosParsed);
        };

        fetchHolidays();
    }, [activeStartDate]);

    const tileContent = ({ date, view }) => {
        if (view !== "month") return null;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const dayIso = formatDate(date);

        // ---------------- FERIADOS ----------------
        const feriado = feriados.find((f) => f.date === dayIso);
        if (feriado) {
            return (
                <div
                    style={{
                        background: "linear-gradient(135deg, rgba(220,53,69,0.15), rgba(220,53,69,0.05))",
                        color: "#b91c1c",
                        fontSize: "0.75rem",
                        textAlign: "center",
                        borderRadius: "8px",
                        padding: "6px 8px",
                        fontWeight: 600,
                        lineHeight: 1.3,
                        maxWidth: "90%",
                        margin: "4px auto",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                        border: "1px solid rgba(220,53,69,0.25)",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    title={feriado.name}
                >
                    {feriado.name}
                </div>
            );
        }

        if (isWeekend(date)) return null;

        // ---------------- EVENTOS ----------------
        const dayEventos = formattedEventos.filter((ev) => {
            const d = ev.extendedProps?.date;
            return d && formatDate(parseLocalDate(d)) === dayIso;
        });

        // ---------------- TASKS ----------------
        const dayCreatedTasks = formattedTasks.filter((t) => {
            const inicio = parseLocalDate(t.extendedProps?.data_inicio);
            return inicio && formatDate(inicio) === dayIso;
        });

        const dayScheduledTasks = formattedTasks.filter((t) => {
            const inicio = parseLocalDate(t.extendedProps?.data_inicio);
            const limite = parseLocalDate(t.extendedProps?.data_limite);
            const conclusao = parseLocalDate(t.extendedProps?.dataConclusao);
            const estado = t.extendedProps?.estado?.value;

            if (dayIso !== formatDate(today)) return false;
            if (estado === 2) return false;
            if (!inicio) return false;

            const endDate = conclusao || limite;
            return endDate && inicio <= today && today <= endDate;
        });

        const dayCompletedTasks = formattedTasks.filter((t) => {
            const conclusao = parseLocalDate(t.extendedProps?.dataConclusao);
            const estado = t.extendedProps?.estado?.value;
            return conclusao && formatDate(conclusao) === dayIso && estado === 6;
        });

        const futureCreatedTasks = futureTasks.filter((t) => {
            const inicio = parseLocalDate(t.extendedProps?.data_inicio);
            return inicio && formatDate(inicio) === dayIso && inicio > today;
        });

        const expiredTasks = formattedTasks.filter((t) => {
            const limite = parseLocalDate(t.extendedProps?.data_limite);
            const conclusao = parseLocalDate(t.extendedProps?.dataConclusao);
            const estado = t.extendedProps?.estado?.value;

            return (
                limite &&
                formatDate(limite) === dayIso &&
                limite < today &&
                estado !== 6 &&
                !conclusao
            );
        });

        // ---------------- TICKETS ----------------
        const dayTickets = tickets.filter((t) => {
            const d = t.extendedProps?.date;
            return d && formatDate(parseLocalDate(d)) === dayIso;
        });

        // ---------------- CONTADORES ----------------
        const createdCount = dayCreatedTasks.length;
        const scheduledCount = dayScheduledTasks.length;
        const completedCount = dayCompletedTasks.length;
        const futureCount = futureCreatedTasks.length;
        const expiredCount = expiredTasks.length;
        const ticketsCount = dayTickets.length;
        const eventosCount = dayEventos.length;

        if (
            !createdCount &&
            !scheduledCount &&
            !completedCount &&
            !futureCount &&
            !expiredCount &&
            !ticketsCount &&
            !eventosCount
        ) {
            return null;
        }

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: 4,
                }}
            >
                {/* Eventos */}
                {eventosCount > 0 && (
                    <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
                        <i className={icon.evento.className} style={icon.evento.style}></i>
                        <span>{eventosCount}</span>
                    </div>
                )}

                {/* Tarefas */}
                {createdCount > 0 && (
                    <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
                        <i className={icon.criar.className} style={icon.criar.style}></i>
                        <span>{createdCount}</span>
                    </div>
                )}
                {scheduledCount > 0 && (
                    <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
                        <i className={icon.agendado.className} style={icon.agendado.style}></i>
                        <span>{scheduledCount}</span>
                    </div>
                )}
                {completedCount > 0 && (
                    <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
                        <i className={icon.concluida.className} style={icon.concluida.style}></i>
                        <span>{completedCount}</span>
                    </div>
                )}
                {futureCount > 0 && (
                    <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
                        <i className={icon.criar.className} style={icon.criar.style}></i>
                        <span>{futureCount}</span>
                    </div>
                )}
                {expiredCount > 0 && (
                    <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
                        <i className={icon.expirada.className} style={icon.expirada.style}></i>
                        <span>{expiredCount}</span>
                    </div>
                )}

                {/* Tickets */}
                {ticketsCount > 0 && (
                    <div style={{ fontSize: "0.8rem", display: "flex", gap: 4 }}>
                        <i className={icon.ticket.className} style={icon.ticket.style}></i>
                        <span>{ticketsCount}</span>
                    </div>
                )}
            </div>
        );
    };

    useEffect(() => {
        // Obter os dados do localStorage
        const storedData = localStorage.getItem('token');

        set_lang(localStorage.getItem('lang'))

        // Parse do JSON para um objeto
        const data = JSON.parse(storedData);

        // Verificar a estrutura e imprimir os dados
        // Se não estiver aninhado duas vezes

        // Lógica se a estrutura estiver aninhada (não está claro o que fazer aqui)
        //console.log('User info aninhado encontrado.');
        //console.log('Profile:', data.user_info.profile);
        //console.log('Id do user logado:', data.user_info.id);

        // Atualiza o estado com os dados do usuário
        setProfile(data.user_info.profile);
        setName(data.user_info.name);
        setuserID(data.user_info.id);

    }, []);

    ///////////////////////////////////////////////////////////////////////////////////

    const getCurrentMonthLocalized = (lang) => {
        const currentDate = new Date();
        const currentMonth = currentDate.toLocaleString(lang, { month: 'long' }); // "lang" define o idioma
        return currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1); // Capitaliza a primeira letra
    };

    const renderChart = () => {
        const totalTasks = underdueTasksThisMonth.length + overdueTasksThisMonth.length;
        const beforeDeadlineCount = underdueTasksThisMonth.length;
        const afterDeadlineCount = overdueTasksThisMonth.length;
        const beforeDeadlinePercentage = (beforeDeadlineCount / totalTasks) * 100 || 0;
        const afterDeadlinePercentage = (afterDeadlineCount / totalTasks) * 100 || 0;
        const mesAtualCapitalized = getCurrentMonthLocalized(lang === 'pt' ? 'pt-BR' : 'en-US');

        return (
            <div className="card shadow-sm border-0 mb-3">
                <div className="card-body text-center py-3">
                    <h5 className="card-title fw-bold mb-4" style={{ color: color.cor1.rgb }}>
                        {language[lang].stats_of} {mesAtualCapitalized} 📈
                    </h5>

                    <div className="row justify-content-center mt-4">
                        {/* Before deadline */}
                        <div className="col-md-4 mb-3">
                            <p className="fw-semibold mb-1 text-success">
                                {language[lang].concluida_antes}: {beforeDeadlineCount}
                            </p>
                            <div className="progress" style={{ height: '24px', borderRadius: '12px' }}>
                                <div
                                    className="progress-bar bg-success fw-semibold"
                                    role="progressbar"
                                    style={{ width: `${beforeDeadlinePercentage}%`, transition: 'width 0.4s ease-in-out' }}
                                    aria-valuenow={beforeDeadlinePercentage}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {beforeDeadlinePercentage.toFixed(0)}%
                                </div>
                            </div>
                        </div>

                        {/* After deadline */}
                        <div className="col-md-4 mb-3">
                            <p className="fw-semibold mb-1 text-danger">
                                {language[lang].concluida_depois}: {afterDeadlineCount}
                            </p>
                            <div className="progress" style={{ height: '24px', borderRadius: '12px' }}>
                                <div
                                    className="progress-bar bg-danger fw-semibold"
                                    role="progressbar"
                                    style={{ width: `${afterDeadlinePercentage}%`, transition: 'width 0.4s ease-in-out' }}
                                    aria-valuenow={afterDeadlinePercentage}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {afterDeadlinePercentage.toFixed(0)}%
                                </div>
                            </div>
                        </div>

                        {/* Total */}
                        <div className="col-md-4 mb-3">
                            <p className="fw-semibold mb-1 text-primary">
                                {language[lang].total_tarefas}: {totalTasks}
                            </p>
                            <div className="progress" style={{ height: '24px', borderRadius: '12px' }}>
                                <div
                                    className="progress-bar fw-semibold"
                                    style={{
                                        width: `${totalTasks ? 100 : 0}%`,
                                        backgroundColor: color.corPrimaria.rgb,
                                        transition: 'width 0.4s ease-in-out',
                                    }}
                                    role="progressbar"
                                    aria-valuenow={100}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    100%
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const calculateDeadline = (dataInicio, dataFim, tasks) => {
        //Tarefas Completas
        if (tasks?.info.estado.labelPt === "Concluído" && tasks?.info.validar === true) {
            return "Concluída";
        } else if (tasks?.info.estado.labelEn === "Completed" && tasks?.info?.validar === true) {
            return "Completed";
        }

        const inicio = new Date(dataInicio);
        const fim = new Date(dataFim);
        const hoje = new Date();

        const diferencaDias = Math.ceil((fim - inicio) / (1000 * 60 * 60 * 24));

        if (hoje > fim) {
            const diasAtraso = Math.ceil((hoje - fim) / (1000 * 60 * 60 * 24));
            return `${language[lang].atrasado} ${diasAtraso} ${language[lang].dia}${diasAtraso !== 1 ? 's' : ''}`;
        } else if (diferencaDias === 0) {
            return language[lang].menos_1dia;
        }

        return `${diferencaDias} ${language[lang].dia}${diferencaDias !== 1 ? 's' : ''}`;
    };

    const getDeadlineStatus = (startDate, limitDate) => {
        return calculateDeadline(startDate, limitDate);
    };

    const sortTasks = (tasks) => {
        const statusOrder = {
            [language[lang].atrasado]: 1,
            [language[lang].menos_1dia]: 2,
            "Default": 3
        };

        return tasks.sort((a, b) => {
            const statusA = getDeadlineStatus(a.info.data_inicio, a.info.data_limite);
            const statusB = getDeadlineStatus(b.info.data_inicio, b.info.data_limite);

            const daysA = typeof statusA === 'string' && statusA.includes('dia') ? parseInt(statusA.match(/\d+/)) : null;
            const daysB = typeof statusB === 'string' && statusB.includes('dia') ? parseInt(statusB.match(/\d+/)) : null;

            if (daysA !== null && daysB !== null) {
                return daysA - daysB;
            }

            return (statusOrder[statusA] || statusOrder["Default"]) - (statusOrder[statusB] || statusOrder["Default"]);
        });
    };

    const sortedData = sortTasks(tasksUser);

    const closeModal = () => {
        setShowWarning(false);
        const currentTime = new Date().getTime();
        localStorage.setItem('modalDismissedTime', currentTime);
        setLastDismissalTime(new Date(currentTime));
    };

    const checkModalDismissal = () => {
        const dismissedTime = localStorage.getItem('modalDismissedTime');
        const currentTime = Date.now();

        return !dismissedTime || (currentTime - dismissedTime) > 7200000; // 7200000 ms = 2 hours
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    const resetModalDismissalTime = () => {
        localStorage.removeItem('modalDismissedTime');
        setLastDismissalTime(null);
    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        const statusesToCheck = [language[lang].late, language[lang].menos_1, language[lang].um_dia, language[lang].dois_dias, language[lang].tres_dias,
        language[lang].quatro_dias, language[lang].cinco_dias, language[lang].seis_dias, language[lang].sete_dias];

        const checkTasksAndModal = () => {
            const hasTasksWithStatuses = sortedData.some(task => {
                const status = getDeadlineStatus(task.info.data_inicio, task.info.data_limite);
                return statusesToCheck.includes(status) && task.info.estado.value !== 6 && task.info.estado.value !== 2;
            });

            if (hasTasksWithStatuses || lastDismissalTime === null) {
                setShowWarning(checkModalDismissal());
            } else {
                setShowWarning(false);
            }
        };

        checkTasksAndModal(); // Initial check
        //resetModalDismissalTime();

        const intervalId = setInterval(() => {
            checkTasksAndModal(); // Check every 2 hours
        }, 7200000); // 7200000 ms = 2 hours

        return () => clearInterval(intervalId); // Clear interval on component unmount

    }, [sortedData, lastDismissalTime]);

    useEffect(() => {
        if (checkModalDismissal()) {
            setShowWarning(true);
        }
    }, []);

    function formatDate(publishedDate) {
        const dateObj = new Date(publishedDate);

        // Extract the day in 'DD/MM/YYYY' format
        const day = dateObj.toLocaleDateString('pt-PT');

        // Extract the time in 'HH:mm' format
        const time = dateObj.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });

        return `${day} - ${time}`;
    }

    const mostRecentEvento = React.useMemo(() => {
        if (!eventos || eventos.length === 0) return null;

        const ativos = eventos.filter((e) => {
            return e?.info?.event_type?.poll_active === true;
        });

        if (ativos.length === 0) return null;

        return [...ativos].sort((a, b) => {
            const dateA = new Date(a.date || a.info?.date || 0);
            const dateB = new Date(b.date || b.info?.date || 0);
            return dateB - dateA;
        })[0];
    }, [eventos]);

    useEffect(() => {
        if (!mostRecentEvento) return;

        const poll = mostRecentEvento.poll || mostRecentEvento.info?.poll;
        if (!poll) return;

        setOptions(poll.options || []);
        setVotes(poll.votes || {});

        const tooltipTriggerList = [].slice.call(
            document.querySelectorAll('[data-bs-toggle="tooltip"]')
        );
        tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
    }, [mostRecentEvento]);

    const savePoll = async () => {
        try {
            let res;

            if (mostRecentEvento?.id) {
                res = await reqPUT(`${api_crud_route}/evento`, mostRecentEvento);
                return res?.data?.id || res?.data?._id || mostRecentEvento.id;

            } else {
                res = await reqPOST(`${api_crud_route}/evento`, mostRecentEvento);
                return res?.data?.id || res?.data?._id;
            }

        } catch (err) {
            console.error("Error saving evento:", err);
        }
    };

    const handle_vote = async (id) => {
        let updatedVotes = { ...votes };
        let updatedVoters = new Set(mostRecentEvento.info.poll?.voters || []);

        if (mostRecentEvento.info.votacao_oculta === "2") {
            if (updatedVoters.has(userID)) {
                await Swal.fire(language.erro, language.insert_error, "error");
                return;
            }

            const result = await Swal.fire({
                title: language[lang].confirmar_voto,
                text: language[lang].confirmar_voto_placeholder,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: language[lang].insert_confirm,
                cancelButtonText: language[lang].insert_cancel,
            });

            if (!result.isConfirmed) return;

            if (parseInt(mostRecentEvento.info.votacao) === 1) {
                Object.keys(updatedVotes).forEach((key) => {
                    updatedVotes[key] = 0;
                });
            }

            updatedVotes[id] = (updatedVotes[id] || 0) + 1;
            updatedVoters.add(userID);
        }

        else {
            const alreadyVoted = updatedVotes[id]?.some((u) => u.userID === userID);

            const result = await Swal.fire({
                title: alreadyVoted ? language[lang].remover_voto : language[lang].confirmar_voto,
                text: alreadyVoted
                    ? language[lang].remover_voto_placeholder
                    : language[lang].confirmar_voto_placeholder,
                icon: "question",
                showCancelButton: true,
                confirmButtonText: language[lang].insert_confirm,
                cancelButtonText: language[lang].insert_cancel,
            });

            if (!result.isConfirmed) return;

            if (parseInt(mostRecentEvento.info.votacao) === 1) {

                Object.keys(updatedVotes).forEach((key) => {
                    updatedVotes[key] = (updatedVotes[key] || []).filter(
                        (u) => u.userID !== userID
                    );
                });
            }

            if (alreadyVoted) {
                updatedVotes[id] = updatedVotes[id].filter((u) => u.userID !== userID);

            } else {
                updatedVotes[id] = [
                    ...(updatedVotes[id] || []),
                    { userID, name, profile },
                ];
            }
        }

        setVotes(updatedVotes);

        mostRecentEvento.info.poll = {
            ...(mostRecentEvento.info.poll || {}),
            options,
            votes: updatedVotes,
            voters: Array.from(updatedVoters),
        };

        set_dados({ ...mostRecentEvento.info });
        await savePoll();

        Swal.fire(language[lang].sucesso, language[lang].escolha, "success");
    };

    const totalVotes = Object.values(votes).reduce((acc, val) => {
        if (Array.isArray(val)) return acc + val.length;
        if (typeof val === "number") return acc + val;
        return acc;
    }, 0);

    return (isloading ?

        <Loader />

        :
        <main>
            {
                dash_tasks !== null && dash_tasks ?
                    <Modal
                        isOpen={showWarning}
                        onRequestClose={closeModal}
                        contentLabel="Task Deadline Warning"
                        style={{
                            overlay: modalStyles.modalOverlay,
                            content: modalStyles.modalContent,
                        }}
                    >
                        {/* Aniversários */}
                        {aniversariosHoje.length > 0 && aniversariosHoje.map(entity => (
                            <div
                                key={entity.id}
                                style={{
                                    padding: "16px 20px",
                                    marginBottom: "12px",
                                    borderRadius: "12px",
                                    background: "#ffffff",
                                    border: "1px solid #e6e6e6",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                                    animation: "fadeIn 0.4s ease",
                                    fontFamily: "Inter, system-ui, sans-serif",
                                }}
                            >
                                <p style={{ margin: 0, fontSize: "1.05rem", fontWeight: 600, color: "#333" }}>
                                    {language[lang].today_is_birthday_of} <strong>{entity.name}</strong>
                                </p>

                                <p style={{ margin: "6px 0 0 0", fontSize: "0.95rem", color: "#666" }}>
                                    {language[lang].congratulations}
                                </p>
                            </div>
                        ))}

                        <br />

                        {/* Tarefas da Semana */}
                        <h2 style={modalStyles.h2Style}>{language[lang].task_week}</h2>

                        <br />

                        <div style={modalStyles.taskListContainer}>
                            {/* MONITOR TASKS */}
                            {monitorTarefas.filter(task => ![2, 6].includes(task.info.estado?.value)).length > 0 && (
                                <>
                                    <h4 style={modalStyles.h2Style}>{language[lang].titulo_monitor}</h4>
                                    <ul style={{ ...modalStyles.pStyle, listStyleType: 'none', padding: 0 }}>
                                        {monitorTarefas
                                            .filter(task => ![2, 6].includes(task.info.estado?.value))
                                            .map(task => {
                                                const deadlineDifference = calculateDeadline(task.info.data_inicio, task.info.data_limite);
                                                return (
                                                    <li key={task.id} style={{ marginBottom: '20px', cursor: 'pointer' }} onClick={() => handleRowClick(task.id)}>
                                                        <div>{language[lang].tarefa_modal} <strong>{task.info.name}</strong></div>
                                                        <div>{language[lang].state} <strong>{task.info.estado ? (lang === 'en' ? task.info.estado.labelEn : task.info.estado.labelPt) : 'Sem Estado'}</strong></div>
                                                        <div>{language[lang].start_data}: {task.info.data_inicio ? new Date(task.info.data_inicio).toLocaleDateString('pt-BR') : 'N/A'}</div>
                                                        <div>{language[lang].data_limite}: {task.info.data_limite ? new Date(task.info.data_limite).toLocaleDateString('pt-BR') : 'N/A'}</div>
                                                        <div style={modalStyles.prazoStyle}>{language[lang].deadline} <strong>{deadlineDifference}</strong></div>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </>
                            )}

                            {/* RESPONSÁVEL TASKS */}
                            {responsavelTarefas.filter(task => ![2, 6].includes(task.info.estado?.value)).length > 0 && (
                                <>
                                    <h4 style={modalStyles.h2Style}>{language[lang].titulo_resp}</h4>
                                    <ul style={{ ...modalStyles.pStyle, listStyleType: 'none', padding: 0 }}>
                                        {responsavelTarefas
                                            .filter(task => ![2, 6].includes(task.info.estado?.value))
                                            .map(task => {
                                                const deadlineDifference = calculateDeadline(task.info.data_inicio, task.info.data_limite);
                                                return (
                                                    <li key={task.id} style={{ marginBottom: '20px', cursor: 'pointer' }} onClick={() => handleRowClick(task.id)}>
                                                        <div>{language[lang].tarefa_modal} <strong>{task.info.name}</strong></div>
                                                        <div>{language[lang].state} <strong>{task.info.estado ? (lang === 'en' ? task.info.estado.labelEn : task.info.estado.labelPt) : 'Sem Estado'}</strong></div>
                                                        <div>{language[lang].start_data}: {task.info.data_inicio ? new Date(task.info.data_inicio).toLocaleDateString('pt-BR') : 'N/A'}</div>
                                                        <div>{language[lang].data_limite}: {task.info.data_limite ? new Date(task.info.data_limite).toLocaleDateString('pt-BR') : 'N/A'}</div>
                                                        <div style={modalStyles.prazoStyle}>{language[lang].deadline} <strong>{deadlineDifference}</strong></div>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </>
                            )}

                            {/* DEPARTAMENTO TASKS 
                            {tarefasDepartamento.filter(task => ![2, 6].includes(task.info.estado?.value)).length > 0 && (
                                <>
                                    <h4 style={modalStyles.h2Style}>{language[lang].titulo_eDepart}</h4>
                                    <ul style={{ ...modalStyles.pStyle, listStyleType: 'none', padding: 0 }}>
                                        {tarefasDepartamento
                                            .filter(task => ![2, 6].includes(task.info.estado?.value))
                                            .map(task => {
                                                const deadlineDifference = calculateDeadline(task.info.data_inicio, task.info.data_limite);
                                                return (
                                                    <li key={task.id} style={{ marginBottom: '20px', cursor: 'pointer' }} onClick={() => handleRowClick(task.id)}>
                                                        <div>{language[lang].tarefa_modal} <strong>{task.info.name}</strong></div>
                                                        <div>{language[lang].state} <strong>{task.info.estado ? (lang === 'en' ? task.info.estado.labelEn : task.info.estado.labelPt) : 'Sem Estado'}</strong></div>
                                                        <div>{language[lang].start_data}: {task.info.data_inicio ? new Date(task.info.data_inicio).toLocaleDateString('pt-BR') : 'N/A'}</div>
                                                        <div>{language[lang].data_limite}: {task.info.data_limite ? new Date(task.info.data_limite).toLocaleDateString('pt-BR') : 'N/A'}</div>
                                                        <div style={modalStyles.prazoStyle}>{language[lang].deadline} <strong>{deadlineDifference}</strong></div>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </>
                            )}*/}

                            {/* IF NO TASKS AT ALL */}
                            {responsavelTarefas.filter(task => ![2, 6].includes(task.info.estado?.value)).length === 0 &&
                                monitorTarefas.filter(task => ![2, 6].includes(task.info.estado?.value)).length === 0 &&
                                tarefasDepartamento.filter(task => ![2, 6].includes(task.info.estado?.value)).length === 0 && (
                                    <p style={modalStyles.pStyle}>
                                        {language[lang].no_tasks_scheduled}
                                        {language[lang].check_back_later}
                                    </p>
                                )}
                        </div>

                        {/* Close Button */}
                        <div style={modalStyles.buttonContainer}>
                            <button style={modalStyles.closeButton} onClick={closeModal}>
                                {language[lang].notice}
                            </button>
                        </div>
                    </Modal>
                    :
                    null
            }

            <div className={`dash-cards body`}>
                <div className="container">
                    {
                        dash_admin !== null && dash_admin ?
                            <div className={`dash-cards header`}>
                                <h2 className="dash-title">{language[lang].dashboard}</h2>
                                <p>{language[lang].dashboard}</p>
                            </div>
                            :
                            <div className={`dash-cards header`}>
                                <h2 className="dash-title">{language[lang].welcome}</h2>
                                <p>{name}</p>
                            </div>
                    }

                    {/* Sondagem mais recente e Agenda */}
                    <div className="row mb-4">
                        {dash_eventos !== null && dash_eventos && mostRecentEvento && (
                            <div className="col-md-7 mb-4 d-flex flex-column">
                                <div className="list-group flex-grow-1">
                                    <div className="d-flex flex-column justify-content-center align-items-center text-center">
                                        <div className="bg-white p-3 rounded shadow-sm mb-4 w-100">
                                            <h2 className="fw-bold">
                                                {lang === "en"
                                                    ? mostRecentEvento?.info?.title?.[0]?.en || ""
                                                    : mostRecentEvento?.info?.title?.[0]?.pt || ""}
                                            </h2>

                                            <h6 className="mb-0 fw-normal">
                                                {lang === "en"
                                                    ? mostRecentEvento?.info?.description?.[0]?.en || ""
                                                    : mostRecentEvento?.info?.description?.[0]?.pt || ""}
                                            </h6>
                                        </div>
                                    </div>

                                    {mostRecentEvento.info.poll.options
                                        .slice()
                                        .sort((a, b) => {
                                            const votesA = mostRecentEvento.info.poll.votes?.[a.id]?.length || 0;
                                            const votesB = mostRecentEvento.info.poll.votes?.[b.id]?.length || 0;
                                            return votesB - votesA; // ordena descrescente
                                        })
                                        .map((o) => {
                                            const votesForOption = mostRecentEvento.info.poll.votes?.[o.id] || [];
                                            const userVoted = Array.isArray(votesForOption)
                                                ? votesForOption.some((u) => u.userID === userID)
                                                : false;

                                            const optionVotes = Array.isArray(votesForOption)
                                                ? votesForOption.length
                                                : votesForOption || 0;

                                            const percent =
                                                totalVotes > 0 ? Math.round((optionVotes / totalVotes) * 100) : 0;

                                            return (
                                                <div
                                                    key={o.id}
                                                    className="list-group-item d-flex flex-column py-2 px-3 mb-2 shadow-sm rounded"
                                                >
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <div>
                                                            <strong className="small">{o.text}</strong>

                                                            {/* Avatares */}
                                                            <div className="d-flex mt-1" style={{ maxWidth: "160px" }}>
                                                                {Array.isArray(votesForOption) &&
                                                                    votesForOption.slice(0, 5).map((u, index) => {
                                                                        const entidade = entidades.current?.find(
                                                                            (e) => e.id === u.userID
                                                                        );

                                                                        let fotoUrl = null;
                                                                        if (entidade?.foto) {
                                                                            try {
                                                                                const fotos = JSON.parse(entidade.foto);
                                                                                if (Array.isArray(fotos) && fotos.length > 0) {
                                                                                    fotoUrl = fotos[0].link;
                                                                                }
                                                                            } catch (err) {
                                                                                console.warn("Foto JSON inválido:", entidade.foto);
                                                                            }
                                                                        }

                                                                        return (
                                                                            <div
                                                                                key={index}
                                                                                className="rounded-circle border border-white bg-secondary d-flex align-items-center justify-content-center text-white fw-bold small"
                                                                                style={{
                                                                                    width: "26px",
                                                                                    height: "26px",
                                                                                    marginLeft: index === 0 ? "0" : "-8px",
                                                                                    fontSize: "11px",
                                                                                    overflow: "hidden",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                data-bs-toggle="tooltip"
                                                                                data-bs-placement="top"
                                                                                title={entidade?.name || "Sem nome"}
                                                                            >
                                                                                {fotoUrl ? (
                                                                                    <img
                                                                                        src={fotoUrl}
                                                                                        alt={entidade?.name || "user"}
                                                                                        className="w-100 h-100"
                                                                                        style={{ objectFit: "cover" }}
                                                                                    />
                                                                                ) : (
                                                                                    entidade?.name
                                                                                        ?.split(" ")
                                                                                        .map((w) => w[0]?.toUpperCase())
                                                                                        .join("")
                                                                                        .substring(0, 2) || "U"
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}

                                                                {votesForOption.length > 5 && (
                                                                    <div
                                                                        className="rounded-circle border border-white bg-light d-flex align-items-center justify-content-center fw-bold small"
                                                                        style={{
                                                                            width: "26px",
                                                                            height: "26px",
                                                                            marginLeft: "-8px",
                                                                            fontSize: "11px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        title={votesForOption
                                                                            .slice(5)
                                                                            .map((u) => {
                                                                                const entidade = entidades.current?.find(
                                                                                    (e) => e.id === u.userID
                                                                                );
                                                                                return entidade?.name;
                                                                            })
                                                                            .join(", ")}
                                                                    >
                                                                        +{votesForOption.length - 5}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Botão votar/remover */}
                                                        <div className="btn-group">
                                                            <button
                                                                type="button"
                                                                onClick={() => handle_vote(o.id)}
                                                                className="btn btn-sm text-white"
                                                                disabled={
                                                                    mostRecentEvento?.info?.isLocked === true || isLocked === true
                                                                }
                                                                style={{
                                                                    backgroundColor: userVoted
                                                                        ? color.corNormal.rgb
                                                                        : color.corNaoUrgente.rgb,
                                                                    minWidth: "100px",
                                                                }}
                                                            >
                                                                {userVoted ? "Remover voto" : "Votar"}
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {/* Barra de progresso */}
                                                    <div className="progress" style={{ height: "6px" }}>
                                                        <div
                                                            className="progress-bar"
                                                            role="progressbar"
                                                            style={{
                                                                width: `${percent}%`,
                                                                backgroundColor: color.corUrgente.hexa,
                                                            }}
                                                            aria-valuenow={percent}
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                        />
                                                    </div>
                                                    <small className="text-muted mt-1">
                                                        {optionVotes} {language[lang].votes} ({percent}%)
                                                    </small>
                                                </div>
                                            );
                                        })}

                                </div>
                            </div>
                        )}

                        {dash_agenda !== null && dash_agenda && (
                            <div className="col-md-5">
                                <div className="row mb-2">
                                    <div className="d-flex justify-content-between align-items-start mb-2 bg-white p-3 rounded shadow-sm">
                                        {/* Legend 
                                        <div className="flex-grow-1" style={{ flex: 2, marginTop: 8, fontSize: 14 }}>                                            
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <i className={icon.criar.className} style={icon.criar.style}></i>
                                                <span>{language[lang].tarefas_criadas}</span>
                                            </div>
                                           
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <i className={icon.agendado.className} style={icon.agendado.style}></i>
                                                <span>{language[lang].tarefas_agendadas}</span>
                                            </div>
                                         
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <i className={icon.concluida.className} style={icon.concluida.style}></i>
                                                <span>{language[lang].tarefas_concluidas}</span>
                                            </div>
                                        
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <i className={icon.expirada.className} style={icon.expirada.style}></i>
                                                <span>{language[lang].tarefas_expiradas}</span>
                                            </div>
                                        </div>
                                        */}

                                        {/* Calendar */}
                                        <style>{calendarStyles}</style>
                                        <div>
                                            <Calendar
                                                onClickDay={(d) => {
                                                    setSelectedDate(d);
                                                    if (selectedDate) {
                                                        handleRowEventClick(selectedDate.id);
                                                    }
                                                }}
                                                value={selectedDate}
                                                activeStartDate={activeStartDate}
                                                onActiveStartDateChange={({ activeStartDate }) =>
                                                    setActiveStartDate(activeStartDate)
                                                }
                                                tileContent={tileContent}
                                                className="custom-calendar"
                                                locale={lang}
                                                calendarType="US"
                                                tileDisabled={({ date }) => {
                                                    const day = date.getDay();
                                                    return day === 0 || day === 6;
                                                }}

                                            />
                                            <Link
                                                id={"ce_" + selectedDate?.id}
                                                className="d-none"
                                                to={{
                                                    pathname: "agenda",
                                                    state: { item: selectedDate, operation: "view" },
                                                }}
                                                replace
                                            >
                                                <i className="bi bi-eye"></i>
                                            </Link>
                                        </div>
                                        {console.log('Selected Date:', selectedDate)}
                                        {console.log('Active Start Date:', activeStartDate)}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="d-flex flex-column align-items-stretch mb-4">
                        <div className="row d-flex flex-wrap">
                            {
                                dash_news !== null && dash_news ?
                                    <div className="col-md-4 d-flex flex-column">
                                        <section
                                            className="d-flex flex-column flex-grow-1"
                                            style={{
                                                padding: '15px',
                                                backgroundColor: color.cor3.hexa,
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                            }}
                                        >
                                            <h4
                                                style={{
                                                    color: color.cor1.hexa,
                                                    marginTop: '2%',
                                                    fontSize: '1.4rem',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {language[lang].news}
                                            </h4>
                                            <div
                                                id="newsCarousel"
                                                className="carousel slide"
                                                data-bs-ride="carousel"
                                                data-bs-interval="10000"
                                                style={{
                                                    width: '100%',
                                                    height: '250px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                <div className="carousel-inner" style={{ width: '100%', height: '100%' }}>
                                                    {noticias
                                                        .filter((news) => new Date(news.info.date.avaiable) > new Date())
                                                        .map((news, index) => (
                                                            <div
                                                                className={`carousel-item ${index === 0 ? 'active' : ''}`}
                                                                key={news.id}
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => handleRowClick(news.id)}
                                                            >
                                                                <div
                                                                    style={{
                                                                        padding: '30px',
                                                                        background: color.cor3.rgb,
                                                                        borderRadius: '8px',
                                                                        transition: 'transform 0.3s',
                                                                        overflow: 'hidden',
                                                                    }}
                                                                >
                                                                    {news.content.map((item, idx) => (
                                                                        <div key={idx} style={{ marginBottom: '10px' }}>
                                                                            <h5
                                                                                style={{
                                                                                    color: color.cor1.hexa,
                                                                                    fontSize: '1.3rem',
                                                                                    textAlign: 'start',
                                                                                }}
                                                                            >
                                                                                {truncateText(item.title || item.name, 6)}
                                                                            </h5>
                                                                            <p
                                                                                style={{
                                                                                    fontSize: '0.9rem',
                                                                                    lineHeight: '1.5',
                                                                                    color: color.cor1.hexa,
                                                                                    textAlign: 'start',
                                                                                }}
                                                                            >
                                                                                {truncateText(item.abstract, 24)}
                                                                            </p>
                                                                        </div>
                                                                    ))}
                                                                    <p
                                                                        style={{
                                                                            fontStyle: 'italic',
                                                                            color: color.corCinza.hexa,
                                                                            fontSize: '0.8rem',
                                                                            textAlign: 'center',
                                                                        }}
                                                                    >
                                                                        <em>{formatDate(news.info.date.published)}</em>
                                                                    </p>
                                                                    <p
                                                                        style={{
                                                                            fontStyle: 'italic',
                                                                            color: color.corCinza.hexa,
                                                                            fontSize: '0.8rem',
                                                                            textAlign: 'center',
                                                                        }}
                                                                    >
                                                                        <em>{news.info.source.text}</em>
                                                                    </p>
                                                                </div>
                                                                <Link
                                                                    id={'c_' + news.id}
                                                                    className="d-none"
                                                                    to={{
                                                                        pathname: 'site_news_view',
                                                                        state: { item: news, operation: 'view' },
                                                                    }}
                                                                    replace
                                                                >
                                                                    <i className="bi bi-eye"></i>
                                                                </Link>
                                                            </div>
                                                        ))}
                                                </div>

                                                <button
                                                    className="carousel-control-prev"
                                                    type="button"
                                                    data-bs-target="#newsCarousel"
                                                    data-bs-slide="prev"
                                                >
                                                    <span
                                                        className="carousel-control-prev-icon"
                                                        aria-hidden="true"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderRadius: '50%',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            marginLeft: '-50%'
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                fontSize: '24px',
                                                                color: color.corCinza.rgb,
                                                                fontWeight: 'bold',
                                                            }}
                                                        >
                                                            &lt;
                                                        </span>
                                                    </span>
                                                    <span className="visually-hidden">Anterior</span>
                                                </button>
                                                <button
                                                    className="carousel-control-next"
                                                    type="button"
                                                    data-bs-target="#newsCarousel"
                                                    data-bs-slide="next"
                                                >
                                                    <span
                                                        className="carousel-control-next-icon"
                                                        aria-hidden="true"
                                                        style={{
                                                            backgroundColor: 'transparent',
                                                            borderRadius: '50%',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            marginRight: '-50%'
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                fontSize: '24px',
                                                                color: color.corCinza.rgb,
                                                                fontWeight: 'bold',
                                                            }}
                                                        >
                                                            &gt;
                                                        </span>
                                                    </span>
                                                    <span className="visually-hidden">Próxima</span>
                                                </button>

                                                <div className="carousel-indicators" style={{ bottom: '-15px' }}>
                                                    {noticias
                                                        .filter((news) => new Date(news.info.date.avaiable) > new Date())
                                                        .map((_, index) => (
                                                            <button
                                                                key={index}
                                                                type="button"
                                                                data-bs-target="#newsCarousel"
                                                                data-bs-slide-to={index}
                                                                className={index === 0 ? 'active' : ''}
                                                                aria-label={`Slide ${index + 1}`}
                                                                style={{
                                                                    backgroundColor: index === 0 ? color.cor1.rgb : color.corCinza.rgb,
                                                                    width: '7px',
                                                                    height: '7px',
                                                                    borderRadius: '50%',
                                                                    margin: '0 3px',
                                                                }}
                                                            ></button>
                                                        ))}
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                    :
                                    null
                            }
                            {
                                dash_tasks !== null && dash_tasks ?
                                    <div className="col-md-4 d-flex">
                                        <div className="bg-white p-3" style={{ height: '100%', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', flex: 1 }}>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <div className='w-100'>
                                                    <h4
                                                        style={{
                                                            color: color.cor1.hexa,
                                                            marginTop: '2%',
                                                            fontSize: '1.3rem',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {language[lang].deadlines}
                                                    </h4>
                                                    <div
                                                        style={{
                                                            maxHeight: '250px',
                                                            overflowY: 'auto',
                                                            overflowX: 'hidden',
                                                            borderRadius: '5px'
                                                        }}
                                                    >
                                                        {sortedTasks.length > 0 ? (
                                                            sortedTasks.map((task, index) => {
                                                                const prioridadeLabel = task.info.prioridade
                                                                    ? lang === 'en'
                                                                        ? task.info.prioridade.labelEn
                                                                        : task.info.prioridade.labelPt
                                                                    : language[lang].no_priority;

                                                                const prioridadeStyle = getPrioridadeStyle(prioridadeLabel);

                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        onClick={() => handleRowClick(task.id)}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            padding: '10px',
                                                                            borderBottom: '1px solid #ddd',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'space-between'
                                                                        }}
                                                                    >
                                                                        <h5
                                                                            style={{
                                                                                margin: '0',
                                                                                fontSize: '0.8rem',
                                                                                color: '#333',
                                                                                flex: 1,
                                                                                marginRight: '5%'
                                                                            }}
                                                                        >
                                                                            {task.info.name}
                                                                        </h5>
                                                                        <span
                                                                            style={{
                                                                                padding: '0px 20px',
                                                                                borderRadius: '20px',
                                                                                fontSize: '0.8rem',
                                                                                textAlign: 'center',
                                                                                ...prioridadeStyle
                                                                            }}
                                                                        >
                                                                            {prioridadeLabel}
                                                                        </span>
                                                                        <Link
                                                                            id={'c_' + task.id}
                                                                            className="d-none"
                                                                            to={{
                                                                                pathname: 'intranet_tarefa_view',
                                                                                state: { item: task, operation: 'view' },
                                                                            }}
                                                                            replace
                                                                        >
                                                                            <i className="bi bi-eye"></i>
                                                                        </Link>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <p>{language[lang].no_tasks_scheduled}</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                dash_tasks !== null && dash_tasks ?
                                    <div className="col-md-4 d-flex">
                                        <div className="bg-white p-3" style={{ height: '100%', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', flex: 1 }}>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <div>
                                                    <h4
                                                        style={{
                                                            color: color.cor1.hexa,
                                                            marginTop: '2%',
                                                            fontSize: '1.4rem',
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {/*{language[lang].sondagem}*/}

                                                        {/*ESTADO DAS TAREFAS */}
                                                        <GraficoPizzaEstadoTarefas lang={lang} > </GraficoPizzaEstadoTarefas>
                                                        {/* <GraficoDepartamentos lang={lang} >   </GraficoDepartamentos> */}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </div>

                    <br />

                    {/* Tabelas */}
                    <div className="bg-white p-4" style={{ borderRadius: '12px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)' }}>
                        {/* Responsável pelas Tarefas ou Individuais */}
                        {dash_tasks !== null && dash_tasks && responsavelTarefas.length > 0 && (
                            <div className="row mb-4">
                                <div className="col">
                                    <div className="div-table">
                                        <div className="table-body interlocutores-list table-responsive">
                                            <table className="table interlocutores-list table-hover table-bordered align-middle">
                                                <thead className="text-center align-middle">
                                                    <tr>
                                                        {tableConfig.headers.map((header) => (
                                                            <th
                                                                key={header.key}
                                                                className="p-3"
                                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                                onClick={() => handleSort(header.key)}
                                                            >
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <span>{header.label}</span>
                                                                    <span>
                                                                        {sortOrder.key === header.key ? (
                                                                            sortOrder.direction === 'asc' ? '↑' : '↓'
                                                                        ) : (
                                                                            '⇅'
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {orderTasks.map((task) => (
                                                        <tr
                                                            key={task.id}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => handleRowClick(task.id)}
                                                        >
                                                            <td style={{ width: '25%' }}>{task.info.name}</td>

                                                            <td style={{ width: '20%' }}>
                                                                {task.info.dataConclusao
                                                                    ? new Date(task.info.dataConclusao).toLocaleDateString('pt-BR')
                                                                    : task.info.estado?.value === 6
                                                                        ? `${language[lang].por_rever}...`
                                                                        : `${language[lang].por_submeter}...`}
                                                            </td>

                                                            <td style={{ width: '20%' }}>
                                                                {task.info.solucao?.dataSubmissao
                                                                    ? new Date(task.info.solucao.dataSubmissao).toLocaleDateString('pt-BR')
                                                                    : language[lang].por_submeter + '...'}
                                                            </td>

                                                            <td
                                                                style={{
                                                                    width: '20%',
                                                                    color: tableConfig.getCellColor(task),
                                                                }}
                                                            >
                                                                {task.info.data_limite
                                                                    ? new Date(task.info.data_limite).toLocaleDateString('pt-BR')
                                                                    : language[lang].por_submeter + '...'}
                                                            </td>

                                                            <td
                                                                style={{
                                                                    width: '15%',
                                                                    ...getEstadoStyle(task.info.estado, lang),
                                                                }}
                                                            >
                                                                {task.info.estado && (
                                                                    <>
                                                                        {lang === 'pt'
                                                                            ? task.info.estado.labelPt
                                                                            : lang === 'en'
                                                                                ? task.info.estado.labelEn
                                                                                : ''}
                                                                    </>
                                                                )}
                                                                <Link
                                                                    id={'c_' + task.id}
                                                                    className="d-none"
                                                                    to={{
                                                                        pathname: 'tarefa_regist',
                                                                        state: { item: task, operation: 'edit' },
                                                                    }}
                                                                    replace
                                                                >
                                                                    <i className="bi bi-eye"></i>
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Tarefas por Validar */}
                        {dash_tasks !== null && dash_tasks && tarefasNaoValidadas.length > 0 && (
                            <div className="row mb-4">
                                <div className="col">
                                    <div className="div-table">
                                        <div className="table-body interlocutores-list table-responsive">
                                            <table className="table interlocutores-list table-hover table-bordered align-middle">
                                                <thead className="text-center align-middle">
                                                    <tr>
                                                        {[
                                                            { key: 'name', label: language[lang].tarefas_por_validar },
                                                            { key: 'data_realizacao', label: language[lang].data_realizacao },
                                                            { key: 'data_submissao', label: language[lang].data_submissao },
                                                            { key: 'data_limite', label: language[lang].data_limite },
                                                            { key: 'estado', label: language[lang].table_state },
                                                        ].map((header) => (
                                                            <th
                                                                key={header.key}
                                                                className="p-3"
                                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                                onClick={() => handleSort(header.key)}
                                                            >
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <span>{header.label}</span>
                                                                    <span>
                                                                        {sortOrder.key === header.key ? (
                                                                            sortOrder.direction === 'asc' ? '↑' : '↓'
                                                                        ) : (
                                                                            '⇅'
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {tarefasNaoValidadas
                                                        .sort((a, b) => new Date(a.info.data_limite) - new Date(b.info.data_limite))
                                                        .map((task) => (
                                                            <tr
                                                                key={task.id}
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => handleRowClick(task.id)}
                                                            >
                                                                <td style={{ width: '25%' }}>{task.info.name}</td>
                                                                <td style={{ width: '20%' }}>
                                                                    {task.info.dataConclusao
                                                                        ? new Date(task.info.dataConclusao).toLocaleDateString('pt-BR')
                                                                        : language[lang].por_submeter + '...'}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    {task.info.solucao?.dataSubmissao
                                                                        ? new Date(task.info.solucao.dataSubmissao).toLocaleDateString('pt-BR')
                                                                        : language[lang].por_submeter + '...'}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        width: '20%',
                                                                        color: tableConfig.getCellColor(task),
                                                                    }}
                                                                >
                                                                    {task.info.data_limite
                                                                        ? new Date(task.info.data_limite).toLocaleDateString('pt-BR')
                                                                        : language[lang].por_submeter + '...'}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        width: '15%',
                                                                        ...getEstadoStyle(task.info.estado, lang),
                                                                    }}
                                                                >
                                                                    {task.info.estado && (
                                                                        <>
                                                                            {lang === 'pt'
                                                                                ? task.info.estado.labelPt
                                                                                : lang === 'en'
                                                                                    ? task.info.estado.labelEn
                                                                                    : ''}
                                                                        </>
                                                                    )}
                                                                    <Link
                                                                        id={'c_' + task.id}
                                                                        className="d-none"
                                                                        to={{
                                                                            pathname: 'tarefa_regist',
                                                                            state: { item: task, operation: 'edit' },
                                                                        }}
                                                                        replace
                                                                    >
                                                                        <i className="bi bi-eye"></i>
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Tarefas Validadas */}
                        {dash_tasks !== null && dash_tasks && tarefasValidadas.length > 0 && (
                            <div className="row mb-4">
                                <div className="col">
                                    <div className="div-table">
                                        <div className="table-body interlocutores-list table-responsive">
                                            <table className="table interlocutores-list table-hover table-bordered align-middle">
                                                <thead className="text-center align-middle">
                                                    <tr>
                                                        {[
                                                            { key: 'name', label: language[lang].tarefas_validada },
                                                            { key: 'data_realizacao', label: language[lang].data_realizacao },
                                                            { key: 'data_submissao', label: language[lang].data_submissao },
                                                            { key: 'data_limite', label: language[lang].data_limite },
                                                            { key: 'estado', label: language[lang].table_state },
                                                        ].map((header) => (
                                                            <th
                                                                key={header.key}
                                                                className="p-3"
                                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                                onClick={() => handleSort(header.key)}
                                                            >
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <span>{header.label}</span>
                                                                    <span>
                                                                        {sortOrder.key === header.key ? (
                                                                            sortOrder.direction === 'asc' ? '↑' : '↓'
                                                                        ) : (
                                                                            '⇅'
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {tarefasValidadas
                                                        .sort((a, b) => new Date(a.info.data_limite) - new Date(b.info.data_limite))
                                                        .map((task) => (
                                                            <tr
                                                                key={task.id}
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => handleRowClick(task.id)}
                                                            >
                                                                <td style={{ width: '25%' }}>{task.info.name}</td>
                                                                <td style={{ width: '20%' }}>
                                                                    {task.info.dataConclusao
                                                                        ? new Date(task.info.dataConclusao).toLocaleDateString('pt-BR')
                                                                        : language[lang].por_submeter + '...'}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    {task.info.solucao?.dataSubmissao
                                                                        ? new Date(task.info.solucao.dataSubmissao).toLocaleDateString('pt-BR')
                                                                        : language[lang].por_submeter + '...'}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        width: '20%',
                                                                        color: tableConfig.getCellColor(task),
                                                                    }}
                                                                >
                                                                    {task.info.data_limite
                                                                        ? new Date(task.info.data_limite).toLocaleDateString('pt-BR')
                                                                        : language[lang].por_submeter + '...'}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        width: '15%',
                                                                        ...getEstadoStyle(task.info.estado, lang),
                                                                    }}
                                                                >
                                                                    {task.info.estado && (
                                                                        <>
                                                                            {lang === 'pt'
                                                                                ? task.info.estado.labelPt
                                                                                : lang === 'en'
                                                                                    ? task.info.estado.labelEn
                                                                                    : ''}
                                                                        </>
                                                                    )}
                                                                    <Link
                                                                        id={'c_' + task.id}
                                                                        className="d-none"
                                                                        to={{
                                                                            pathname: 'tarefa_regist',
                                                                            state: { item: task, operation: 'edit' },
                                                                        }}
                                                                        replace
                                                                    >
                                                                        <i className="bi bi-eye"></i>
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="card-body mb-4">
                        <div className="row">
                            {
                                dash_tasks !== null && dash_tasks ?
                                    <div className="bg-white p-3 me-4" style={{ height: '100%', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', flex: 1 }}>

                                        {/* LineChart */}
                                        <div className="d-flex justify-content-center">
                                            <GraficoTCMensal lang={lang} />
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                dash_tasks !== null && dash_tasks ?
                                    <div className="bg-white p-3" style={{ height: '100%', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', flex: 1 }}>

                                        {/* BarChart */}
                                        <div className="d-flex flex-column align-items-center">
                                            <label className="fw-bold mb-2">{language[lang].task_finished} - {language[lang].individual} ✅</label>
                                            <ResponsiveContainer width="100%" height={335}>
                                                <BarChart data={responsavelData} margin={{ top: 10, right: 10, left: 10, bottom: 10 }}>
                                                    <Bar dataKey="onTime" fill={color.corVerde.rgb} name={language[lang].on_time} />
                                                    <Bar dataKey="late" fill={color.corVermelha.rgb} name={language[lang].delayed} />
                                                    <CartesianGrid strokeDasharray="3 3" />
                                                    <XAxis dataKey="label" label={{ position: 'insideBottom', offset: -5 }} />
                                                    <YAxis
                                                        domain={[0, 'dataMax']}
                                                        tickFormatter={(value) => Number.isInteger(value) ? value : ''}
                                                        allowDecimals={false}
                                                        label={{ angle: -90, position: 'insideLeft' }}
                                                    />
                                                    <Tooltip />
                                                    <Legend
                                                        layout="horizontal"
                                                        verticalAlign="top"
                                                        align="right"
                                                        wrapperStyle={{ position: 'absolute', top: 0, right: 0, paddingRight: '10px', borderRadius: '10px' }}
                                                    />
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                dash_energy !== null && dash_energy ?
                                    <div className="bg-white p-3" style={{ borderRadius: '12px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)', marginTop: '20px' }}>
                                        {/* Energy Graphs */}
                                        <div className="row mb-5" style={{ marginLeft: '8px' }}>
                                            <div className="col-md-6">
                                                <h5 className="fw-bold mb-3">{language[lang].consumo_mes || 'Consumo por Mês'}</h5>

                                                <Link
                                                    to={{ pathname: 'intranet_maintenance_energy_list' }}
                                                    replace
                                                    style={{ display: 'block', cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
                                                >
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <LineChart data={monthlyDataByType.consumeArray}>
                                                            <XAxis dataKey="label" />
                                                            <YAxis />
                                                            <Tooltip content={<CustomTooltipConsume />} />
                                                            <Legend />
                                                            {tepByLabel.map(entry => (
                                                                <Line
                                                                    key={`consume-${entry.name}`}
                                                                    type="monotone"
                                                                    dataKey={entry.name}
                                                                    stroke={colorMap[entry.name]}
                                                                    strokeWidth={2}
                                                                    name={entry.name}
                                                                />
                                                            ))}
                                                        </LineChart>
                                                    </ResponsiveContainer>
                                                </Link>
                                            </div>

                                            <div className="col-md-6">
                                                <h5 className="fw-bold mb-3">{language[lang].custo_iva_mes || 'Custo com IVA por Mês'}</h5>

                                                <Link
                                                    to={{ pathname: 'intranet_maintenance_energy_list' }}
                                                    replace
                                                    style={{ display: 'block', cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
                                                >
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <LineChart data={monthlyDataByType.custoIvaArray}>
                                                            <XAxis dataKey="label" />
                                                            <YAxis />
                                                            <Tooltip content={<CustomTooltipCustoIva />} />
                                                            <Legend />
                                                            {tepByLabel.map(entry => (
                                                                <Line
                                                                    key={`custo-${entry.name}`}
                                                                    type="monotone"
                                                                    dataKey={entry.name}
                                                                    stroke={colorMap[entry.name]}
                                                                    strokeDasharray="4 2"
                                                                    strokeWidth={2}
                                                                    name={entry.name}
                                                                />
                                                            ))}
                                                        </LineChart>
                                                    </ResponsiveContainer>
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="row mt-5" style={{ marginLeft: '8px' }}>
                                            <div className="col-md-6">
                                                <h5 className="fw-bold mb-3">{language[lang].pie_chart_title || 'Distribuição de TEP por Tipo de Energia'}</h5>

                                                <Link
                                                    to={{ pathname: 'intranet_maintenance_energy_list' }}
                                                    replace
                                                    style={{ display: 'block', cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
                                                >
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <PieChart>
                                                            <Pie
                                                                data={tepByLabel}
                                                                dataKey="value"
                                                                nameKey="name"
                                                                cx="50%"
                                                                cy="50%"
                                                                outerRadius={100}
                                                                fill="#8884d8"
                                                                label
                                                            >
                                                                {tepByLabel.map((entry) => (
                                                                    <Cell key={`cell-${entry.name}`} fill={colorMap[entry.name]} />
                                                                ))}

                                                            </Pie>
                                                            <Tooltip content={<CustomTooltipConsume />} />
                                                        </PieChart>
                                                    </ResponsiveContainer>
                                                </Link>
                                            </div>

                                            <div className="col-md-6">
                                                <h5 className="fw-bold mb-3">
                                                    {language[lang].pie_chart_title || 'Distribuição de TEP por Tipo de Energia'}
                                                </h5>

                                                <Link
                                                    to={{ pathname: 'intranet_maintenance_energy_list' }}
                                                    replace
                                                    style={{ display: 'block', cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
                                                >
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <BarChart data={enrichedTepByLabel}>
                                                            <Bar
                                                                dataKey="value"
                                                                nameKey="name"
                                                                label
                                                            >
                                                                {enrichedTepByLabel.map((entry) => (
                                                                    <Cell key={`cell-${entry.name}`} fill={colorMap[entry.name]} />
                                                                ))}
                                                            </Bar>
                                                            <XAxis dataKey="name" />
                                                            <YAxis />
                                                            <Tooltip content={<CustomToolBar />} />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    :
                                    null
                            }
                        </div>
                    </div>

                    {/* Estatisticas */}
                    <div className="bg-white p-4 mb-4" style={{ borderRadius: '12px', boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)' }}>
                        {dash_tasks !== null && dash_tasks && tarefasConcluidas > 0 || underdueTasks.length > 0 || overdueTasks.length > 0 || responsavelTarefas.length > 0 ?
                            <div>
                                <div className="row mb-4">
                                    {renderChart()}
                                </div>

                                <div className="card-single d-none">
                                    <div className="row mb-4">
                                        <div style={containerStyles.container}>
                                            <span style={containerStyles.label}>{language[lang].numero_tarefas_concluidas}</span>
                                            <span style={containerStyles.value}>{tarefasConcluidas}</span>
                                        </div>

                                        <div style={containerStyles.container}>
                                            <span style={containerStyles.label}>{language[lang].concluida_antes}</span>
                                            <span style={containerStyles.value}>{underdueTasks.length}</span>
                                        </div>

                                        <div style={containerStyles.container}>
                                            <span style={containerStyles.label}>{language[lang].conluida_depois} </span>
                                            <span style={containerStyles.value}>{overdueTasks.length}</span>
                                        </div>

                                        <div style={containerStyles.container}>
                                            <span style={containerStyles.label}>{language[lang].total_tarefas}</span>
                                            <span style={containerStyles.value}>{responsavelTarefas.length}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                        }

                    </div>
                </div>
            </div>
        </main >
    )
}